import { render } from "./App.vue?vue&type=template&id=3bdcecc6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3bdcecc6&lang=scss"
script.render = render

export default script